// import logo from './logo.svg';
// import './App.css';
import React from 'react';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Dts from './components/Dts';
import CV from './components/CV';
import BSc from './components/BSc';
import Playlists from './components/Playlists';
import MC from './components/MC';
import Terraria from './components/Terraria';
import Factorio from './components/Factorio';
import CubeTeg from './components/CubeTeg';
import styles from './styles/App.module.css';

const OJEE = process.env.REACT_APP_OJEE;
const PITVISOR = process.env.REACT_APP_PITVISOR;

// The aim tracker moved to ow.ojee.net (alongside the rank tracker). The
// dashboard's SPA rule serves this bundle for /ow, so this handoff is what
// carries a visitor across; public/_redirects states the same intent at the edge.
function OwRedirect() {
    useEffect(() => {
        window.location.replace('https://ow.ojee.net/aim/');
    }, []);
    return (
        <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', textAlign: 'center', gap: 8 }}>
            <div>
                <p style={{ marginBottom: 4 }}>the aim tracker moved to ow.ojee.net</p>
                <a href="https://ow.ojee.net/aim/">continue to the aim tracker &#8594;</a>
            </div>
        </div>
    );
}

function AppContent() {
    const location = useLocation();
    // full-bleed iframe pages ship their own HUD, so the site navbar would
    // just stack a second bar on top of it
    const FULL_BLEED = ['/', '', '/mc', '/playlists', '/dts', '/edu', '/terraria', '/factorio'];
    const isHome = FULL_BLEED.includes(location.pathname);

    return (
        <>
            {!isHome && <Navbar />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/pitvisor" redirectTo={PITVISOR} />
                <Route path="/pitvisor-tos" redirectTo={PITVISOR + "/tos"} />
                <Route path="/pitvisor-priv" redirectTo={PITVISOR + "/priv"} />
                <Route path="/bluef1ag" redirectTo={PITVISOR} />
                <Route path="/bluef1ag-tos" redirectTo={PITVISOR + "/tos"} />
                <Route path="/bluef1ag-priv" redirectTo={PITVISOR + "/priv"} />
                <Route path="/bluef1ag-web" redirectTo={PITVISOR} />
                <Route path="/cv" element={<CV />} />
                <Route path="/bsc" element={<BSc />} />
                <Route path="/playlists" element={<Playlists />} />
                <Route path="/dts" element={<Dts />} />
                <Route path="/edu" element={<Navigate to="/dts" replace />} />
                <Route path="/mc" element={<MC />} />
                <Route path="/terraria" element={<Terraria />} />
                <Route path="/factorio" element={<Factorio />} />
                <Route path="/cubeteg" element={<CubeTeg />} />
                <Route path="/ow" element={<OwRedirect />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </>
    );
}

function App() {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // get root and add css
    const root = document.getElementById('root');
    root.classList.add(styles.root);

    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;